module.exports = "<button mat-raised-button color=\"primary\" (click)=\"downloadFile()\" [disabled]=\"disable\">Descargar</button>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/download-zip-package/download-zip-package.component.html
// module id = ../../../../../src/app/components/download-zip-package/download-zip-package.component.html
// module chunks = main